import React from 'react'
import style from './articles.style'

const RetailCrm = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Подключение Retail CRM</h2>
      <h3>Настройка подключения в Дата Споттере</h3>
      <p>
        В настроках подключения необходимо указать часть "subdomain" адреса
        вашей CRM. Например, если адрес вашей
        https://test-account.retailcrm.ru/, то subdomain будет "test-account".
      </p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/retailcrm7.png" alt="true" />
        <figcaption>Подключение RetailCRM</figcaption>
      </figure>

      <p>
        В поле API KEY необхоимо скопировать ключ доступа к API из вашей CRM
      </p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/retailcrm1.png" alt="true" />
        <figcaption>Подключение RetailCRM</figcaption>
      </figure>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/retailcrm2.png" alt="true" />
        <figcaption>Подключение RetailCRM</figcaption>
      </figure>

      <p>
        После сохранения настроек подключения скопируйте автоматически
        сгенерированный код - он вам пригодится на этапе настройки в RetailCRM
      </p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/retailcrm8.png" alt="true" />
        <figcaption>Подключение RetailCRM</figcaption>
      </figure>

      <h2>Настройка подключения в RetailCRM</h2>
      <p>
        Перейдите в раздел "Администрирование" -> "Коммуникации" -> "Триггеры" и
        создайте новый триггер.
      </p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/retailcrm3.png" alt="true" />
        <figcaption>Подключение RetailCRM</figcaption>
      </figure>

      <p>
        Заполните обязательные поля, а также обратите внимание на подчеркнутые
        красной чертой поля - заполните их в соответствие со скриншотом
      </p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/retailcrm4.png" alt="true" />
        <figcaption>Подключение RetailCRM</figcaption>
      </figure>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/retailcrm5.png" alt="true" />
        <figcaption>Подключение RetailCRM</figcaption>
      </figure>

      <p>
        Обратите внимание на последний параметр - в поле со значением необходимо
        вставить код, полученный на шаге подключения CRM в Дата Споттере
      </p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/retailcrm6.png" alt="true" />
        <figcaption>Подключение RetailCRM</figcaption>
      </figure>
    </article>
  )
}

export default style(RetailCrm)
